import { client } from '@/api/client'

export type ConsentLevel = 'full' | 'partial' | 'none'

export interface PendingRecord {
  id: number
  child_id: number
  child_name: string
  year: number
}

export interface CheckResult {
  pending: boolean
  records: PendingRecord[]
  language: 'el' | 'en'
}

export interface ConsentPayload {
  medical_data_acknowledged: boolean
  personal_data_acknowledged: boolean
  medical_consent_level: ConsentLevel
  medical_consent_explanation: string
  personal_consent_level: ConsentLevel
  personal_consent_explanation: string
}

export const checkConsentRefresh = () =>
  client.get<CheckResult>('/consent-refresh-2026/check/').then((r) => r.data)

export const submitConsentRefresh = (payload: ConsentPayload) =>
  client.post('/consent-refresh-2026/submit/', payload).then((r) => r.data)
